











import { Component, Vue } from "vue-property-decorator";
import { AppsCount, DailyActive, DailyVolume, DailyTransactions } from "@/components/apps/header";

@Component({
  components: {
    AppsCount,
    DailyActive,
    DailyTransactions,
    DailyVolume,
  },
})
export default class AppsMonitorHeader extends Vue {}
